<template>
  <section id="roadmap" class="dark:bg-gray-100 dark:text-gray-800">
    <div class="container max-w-5xl px-4 py-12 mx-auto">
      <div class="grid gap-4 mx-4 sm:grid-cols-12">
        <div class="col-span-12 sm:col-span-3">
          <div class="text-center sm:text-left mb-14 before:block before:w-24 before:h-3 before:mb-5 before:rounded-md before:mx-auto sm:before:mx-0 before:dark:bg-emerald-600">
            <h3 class="text-3xl font-semibold">The Journey</h3>
            <span class="text-sm font-bold tracking-wider uppercase dark:text-gray-400">Rise of the Untouchables</span>
          </div>
        </div>
        <div class="relative col-span-12 px-4 space-y-6 sm:col-span-9">
          <div class="col-span-12 space-y-12 relative px-4 sm:col-span-8 sm:space-y-8 sm:before:absolute sm:before:top-2 sm:before:bottom-0 sm:before:w-0.5 sm:before:-left-3 before:dark:bg-gray-500">

            <!-- Phase 1: Meme Genesis -->
            <div class="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:dark:bg-emerald-600">
              <h3 class="text-xl font-semibold tracking-wide">Meme Genesis</h3>
              <p class="mt-3">
                The memecoin era begins! We launch $UNTOUCH with a vision to unite the meme culture with blockchain innovation.
                Our community starts growing, and the journey of becoming Untouchable takes its first steps.
              </p>
            </div>

            <!-- Phase 2: Building the Untouchables -->
            <div class="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:dark:bg-emerald-600">
              <h3 class="text-xl font-semibold tracking-wide">Building the Untouchables</h3>
              <p class="mt-3">
                • Establish a thriving community of memers, dreamers, and doers. <br />
                • Launch contests and challenges to bring out the creativity of the Untouchable Guys. <br />
                • Introduce exclusive NFTs and meme-related perks for early adopters.
              </p>
            </div>

            <!-- Phase 3: Expanding Influence -->
            <div class="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:dark:bg-emerald-600">
              <h3 class="text-xl font-semibold tracking-wide">Expanding Influence</h3>
              <p class="mt-3">
                • Partner with major meme creators and influencers to spread the Untouchable spirit. <br />
                • Roll out real-world utilities for $UNTOUCH, from merch to exclusive event access. <br />
                • Showcase our community’s achievements and impact on meme culture worldwide.
              </p>
            </div>

            <!-- Phase 4: Untouchable Future -->
            <div class="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:dark:bg-emerald-600">
              <h3 class="text-xl font-semibold tracking-wide">Untouchable Future</h3>
              <p class="mt-3">
                • Evolve $UNTOUCH into a symbol of creativity, community, and resilience. <br />
                • Empower Untouchable Guys to drive the next big waves in blockchain and culture. <br />
                • Leave an indelible mark on the world of memecoins and beyond.
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
</script>